import { useContext } from 'react'
import { CheckoutContext } from '../components/CheckoutProvider/CheckoutProvider'

export function useCheckout() {
  const checkoutContext = useContext(CheckoutContext)

  if (!checkoutContext) throw new Error('CheckoutContext has to be used within <CheckoutContext.Provider>')

  return checkoutContext
}
